import CounterItemModel from './CounterItemModel';

const CounterElementModel = {
  elements: [CounterItemModel],
  animationDuration: 0,
};

export default CounterElementModel;
